export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const LOGOUT = "LOGOUT";
export const SET_REGISTER = "SET_REGISTER";
export const ADD_WATCHLIST = "ADD_WATCHLIST";
export const GET_ACTIVE_USER = "GET_ACTIVE_USER";
export const TEMP_UPDATE = "TEMP_UPDATE";
